"use strict";
// This icon file is generated automatically.
Object.defineProperty(exports, "__esModule", { value: true });
var SystemArrowLargeUpFill = { "icon": { "tag": "svg", "attrs": { "viewBox": "32 32 960 960", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M492.16 318.85l-328.4 380.8c-12.2 14.2-1.2 34.98 18.51 34.98h656.77c19.71 0 30.72-20.77 18.52-34.98l-328.4-380.8a25 25 0 00-37 0z" } }] }, "name": "system-arrow-large-up-fill", "theme": "outlined" };
exports.default = SystemArrowLargeUpFill;
